<template>
  <v-card flat class="drawer-card">
    <v-card-text class="drawer-card-text">
      <slot />
    </v-card-text>
    <v-divider />
    <slot name="actions" />
  </v-card>
</template>

<script>
export default {
  name: "DrawerCard",
};
</script>

<style scoped>
.drawer-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.drawer-card-text {
  flex: 1 1 auto;
  overflow-y: auto;
}
</style>
